import Skeleton from 'react-loading-skeleton';

const LoadingCell = () => <Skeleton width="100%" height={14} />;

export { LoadingCell };
